import {PavadinimasApi} from "./pavadinimas.api";

export class AtaskVeiklosDuomenysApi {
  id: any;
  srautoId: any;
  impKiekis: any;
  impSvoris: any;
  pagKiekis: any;
  pagSvoris: any;
  veiklosId: any;
  veiklosPavadinimas!: PavadinimasApi
  srautoPavadinimas!: PavadinimasApi
  visoKiekis: any;
  visoSvoris: any;
  filtroSvoris: any;
  expanded = true;
  insertUser: any;
  updateUser: any;
}
